var React = require('react');

function NextArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M40 1C61.5391 1 79 18.4609 79 40C79 61.5391 61.5391 79 40 79C18.4609 79 0.999999 61.5391 0.999999 40C0.999998 18.4609 18.4609 1 40 1ZM80 40C80 62.0914 62.0914 80 40 80C17.9086 80 2.13558e-07 62.0914 4.76995e-07 40C-1.97367e-06 17.9086 17.9086 2.13558e-07 40 4.76995e-07C62.0914 7.40432e-07 80 17.9086 80 40ZM33 40.8037L33 38.8037L39.5 38.8037L39.5 34.6077L47 39.8038L39.5 45L39.5 40.8037L33 40.8037Z","fill":"currentColor"}));
}

NextArrow.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = NextArrow;

NextArrow.default = NextArrow;
